import React, { createContext, useCallback, useMemo, useState } from "react";
import { Invitation, Party, PromotersOffer, RequestedListing } from "../types";

interface GoingOutSelectedGroupContextData {
  invitations: Invitation[];
  party: Party[]
  requestedListing: RequestedListing[];
  promoterOffers: PromotersOffer[]
  setSelectedAlsoGoingOutGroup: (invitations: Invitation[], party: Party[], requestedListing: RequestedListing[], promoterOffers: PromotersOffer[]) => void;
}

export const AlsoGoingOutSelectedGroupContext = createContext<GoingOutSelectedGroupContextData>({
  invitations: [],
  party: [],
  requestedListing: [],
  promoterOffers: [],
  setSelectedAlsoGoingOutGroup: () => { },
});

export const AlsoGoingOutGroupProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [alsoGoingOutGroupContextData, setContextData] = useState<{ invitations: Invitation[]; party: Party[]; requestedListing: RequestedListing[]; promoterOffers: PromotersOffer[] }>({
    invitations: [],
    party: [],
    requestedListing: [],
    promoterOffers: []
  });

  const setSelectedAlsoGoingOutGroup = useCallback((invitations: Invitation[], party: Party[], requestedListing: RequestedListing[], promoterOffers: PromotersOffer[]) => {
    setContextData({ invitations, party, requestedListing, promoterOffers });
  }, []);

  const value = useMemo(() => ({ ...alsoGoingOutGroupContextData, setSelectedAlsoGoingOutGroup }), [alsoGoingOutGroupContextData, setSelectedAlsoGoingOutGroup]);

  return (
    <AlsoGoingOutSelectedGroupContext.Provider value={value}>
      {children}
    </AlsoGoingOutSelectedGroupContext.Provider>
  );
};
